import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { GetLocalStorageValue } from '../../../_config/utils/get-local-storage-value.util';
import CustomSearch from '../../../v2-components/Antd/Search';
import CustomTable from '../../../v2-components/Antd/Table';
import CustomTabs from '../../../v2-components/Antd/Tabs';
import Loading from '../../../v2-components/Loading';
import { Service } from '../service';
import { generateColumns } from './handle/generate-columns.handle';
import { handleSearchParams } from './handle/search-params.handle';
import { tabOptions } from './handle/tab-options.handle';
import './style.scss';

export default function PreorderListPage() {
	const [data, setData] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [isTableLoading, setIsTableLoading] = useState(false);
	const history = useHistory();
	const location = useLocation();
	const pharmacy = GetLocalStorageValue('userInfo')?.pharmacy;

	const [page, setPage] = useState(() => {
		const params = new URLSearchParams(location?.search);
		return params.get('page') || 1;
	});
	const [status, setStatus] = useState(() => {
		const params = new URLSearchParams(location?.search);
		return params.get('status') || 'PAYMENT_PENDING';
	});
	const [paginationResponse, setPaginationResponse] = useState();
	const rowKey = 'tracking_id';
	const [sortOrder, setSortOrder] = useState(() => {
		const params = new URLSearchParams(location?.search);
		return params.get('sortOrder') || 'desc';
	});
	const { token } = GetLocalStorageValue('userInfo');
	
	// Inputs de búsqueda
	const [trackingId, setTrackingId] = useState(() => {
		const params = new URLSearchParams(location?.search);
		return params.get('tracking_id');
	});
	const [rut, setRut] = useState(() => {
		const params = new URLSearchParams(location?.search);
		return params.get('rut');
	});
	const [email, setEmail] = useState(() => {
		const params = new URLSearchParams(location?.search);
		return params.get('email');
	});

	// Sincronizar estado con URL
	useEffect(() => {
		const params = new URLSearchParams(location?.search);
		setPage(params.get('page') || 1);
		setStatus(params.get('status') || 'PAYMENT_PENDING');
		setSortOrder(params.get('sortOrder') || 'desc');
		setTrackingId(params.get('tracking_id'));
		setRut(params.get('rut'));
		setEmail(params.get('email'));
	}, [location?.search]);

	const pagination = {
		currentPage: paginationResponse?.current_page,
		pageSize: paginationResponse?.items_per_page,
		totalItems: paginationResponse?.total_items,
	};


	useEffect(() => {
		setIsTableLoading(true);
		const sortBy = status === 'PAYMENT_APPROVED' ? 'payment_approved_date' : 'payment_pending_date';
		new Service().getData({ 
			status, 
			page: Number(page), 
			sortOrder,
			sortBy,
			tracking_id: trackingId,
			rut,
			email
		}, token).then((response) => {
			console.log('API Response for status:', status);
			console.log('Data received:', response.data);
			console.log('Dates order:', response.data?.map(item => ({
				tracking_id: item.tracking_id,
				created_at: item.created_at,
				payment_pending_date: item.payment_pending_date,
				payment_approved_date: item.payment_approved_date
			})));
			setPaginationResponse(response);
			setData(response.data);
		}).catch((error) => {
			console.error("Error fetching data", error);
		})
		.finally(() => {
			setIsTableLoading(false);
			setIsLoading(false); 
		});
	}, [status, page, sortOrder, trackingId, rut, email]);

	const handlePageChange = (newPage) => {
		const searchParams = new URLSearchParams(location?.search);
		searchParams.set('page', newPage);
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};



	const handleSearchCode = (tracking_id) => {
		const searchParams = new URLSearchParams(location?.search);
		const cleanCode = tracking_id ? tracking_id.trim() : '';
		searchParams.set('page', 1);
		if (cleanCode === '') {
			searchParams.delete('tracking_id');
		} else {
			searchParams.set('tracking_id', tracking_id);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleSearchRut = (rut) => {
		const searchParams = new URLSearchParams(location?.search);
		const cleanInput = rut ? rut.trim() : '';
		searchParams.set('page', 1);
		if (cleanInput === '') {
			searchParams.delete('rut');
		} else {
			searchParams.set('rut', cleanInput);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};


	const handleSearchEmail = (email) => {
		const searchParams = new URLSearchParams(location?.search);
		const cleanEmail = email ? email.trim() : '';
		searchParams.set('page', 1);
		if (cleanEmail === '') {
			searchParams.delete('email');
		} else {
			searchParams.set('email', cleanEmail);
		}
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};


	const handleTableChange = (pagination, filters, sorter) => {
		// Solo procesar si la columna ordenable es la de fecha
		if (sorter.columnKey !== 'date') {
			return;
		}

		const searchParams = new URLSearchParams(location?.search);
		const currentOrder = searchParams.get('sortOrder') || 'desc';
		
		// Alternar entre asc y desc
		const newOrder = currentOrder === 'asc' ? 'desc' : 'asc';
		
		searchParams.set('sortOrder', newOrder);
		searchParams.set('page', 1);
		
		history.push({
			pathname: location?.pathname,
			search: handleSearchParams(searchParams),
		});
	};

	const handleTabClick = (key) => {
		const tab = tabOptions(data, status).find((tab) => tab.key === key);
		if (tab) {
			const searchParams = new URLSearchParams(location?.search);
			searchParams.set('status', tab.status);
			searchParams.set('page', 1);
			history.push({
				pathname: location?.pathname,
				search: handleSearchParams(searchParams),
			});
		}
	};

	const getTabsData = () => {
		return tabOptions(data, status);
	};

	const paginationConfig = {
		current: pagination.currentPage,
		pageSize: pagination.pageSize,
		total: pagination.totalItems,
		showSizeChanger: false,
		onChange: (page) => handlePageChange(page),
	};

	const operations = (
		<div className="operations-container">
			<div className="search-input-group">
				<div className="own-order-search-container">
					<CustomSearch 
						placeholder={'N° de Pre-orden'} 
						onSearch={handleSearchCode} 
					/>
				</div>
				<div className="own-order-search-container">
					<CustomSearch 
						placeholder={'N° de RUT'} 
						onSearch={handleSearchRut} 
					/>
				</div>
				<div className="own-order-search-container">
					<CustomSearch 
						placeholder={'e-mail'} 
						onSearch={handleSearchEmail} 
					/>
				</div>
			</div>
		
		</div>
	);

	const initialActiveTab = tabOptions(data, status).find((tab) => tab.status === status)?.key;

	if (isLoading) {
		return <Loading />;
	}
	if (isLoading === false) {
		return (
			<div className="tracking-orders-list-container">
				<Row>
					<Col span={8}>
						<h2>Pre-orden</h2>
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<Col className={'own-order-main-container'}>
							<CustomTabs tabBarExtraContent={operations} onChange={handleTabClick} activeKey={initialActiveTab}>
							{getTabsData().map((tab) => (
								<CustomTabs.TabPane tab={tab.tab} key={tab.key}>
									<CustomTable
										onChange={handleTableChange}
										dataSource={tab.data}
										columns={generateColumns(status, sortOrder, pharmacy)}
										pagination={paginationConfig}
										rowKey={rowKey}
										loading={isTableLoading}
									/>
								</CustomTabs.TabPane>
								))}
							</CustomTabs>
						</Col>
					</Col>
				</Row>
			</div>
		);
	}
}
